import PropTypes from "prop-types"
import { Image } from "./Thumbnail.styles"
import { Link } from "react-router-dom"

const Thumbnail = ({ image, movieId, clickable }) => {
    return (
        <div>
            { clickable ? (
                <Link to={`/${movieId}`}><Image style={{cursor: "pointer"}} src={image} alt='Movie-thumb'/></Link>
            ) : (
                <Image style={{cursor: "pointer"}} src={image} alt='Movie-thumbnail'/>
            )}
            
        </div>
    )
}

Thumbnail.propTypes = {
    image: PropTypes.string,
    movieId: PropTypes.number,
    clickable: PropTypes.bool,
}

export default Thumbnail;
